import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createCouponCodeValidationSchema = Yup.object().shape({
  couponCode: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
